import React from "react";
import ActionDialog from "./ActionDialog";

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  message: string;
  autoDismissMs?: number;
  variant?: "success" | "error";
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  message,
  autoDismissMs = 5000,
  variant = "success",
}) => {
  const isError = variant === "error";

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      iconVariant={variant}
      description={
        <p
          style={{
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "200%",
            textAlign: "center",
            color: "#000000",
            margin: 0,
            width: "100%",
          }}
        >
          {message}
        </p>
      }
      buttonText={isError ? "CLOSE" : undefined}
      onButtonClick={isError ? onClose : undefined}
      buttonColor={isError ? "#000000" : undefined}
      autoDismissMs={autoDismissMs}
      maxWidth="505px"
    />
  );
};

export default SuccessDialog;
